t = require('app/scripts/views/internal/teacup-with-helpers')('board_change_background')

module.exports = t.renderable ({ enabled_customBoardBackgrounds, idMember, upgradeUrl, hasOrganization, upsellEnabled }) ->
  t.div '.board-backgrounds-section-tiles.u-clearfix', ->
    t.div '.board-backgrounds-section-tile.board-backgrounds-photos-tile.js-bg-photos', ->
      t.div '.image'
      t.div '.title', ->
        t.format 'photos'
    t.div '.board-backgrounds-section-tile.board-backgrounds-colors-tile.js-bg-colors', ->
      t.div '.image'
      t.div '.title', ->
        t.format 'colors'

  t.hr '.board-menu-header-divider'

  if !enabled_customBoardBackgrounds && upsellEnabled
    t.div { class: 'bc-ad', id: 'background-ad' }

  if enabled_customBoardBackgrounds || upsellEnabled
    t.h2 ->
      t.format 'custom'

    t.div { class: 'board-backgrounds-list u-relative u-clearfix js-custom-list' + if enabled_customBoardBackgrounds then '' else ' disabled' }, ->

      t.div '.board-background-select.board-background-select-upload.js-uploader', ->
        t.form { action: '/1/member/' + idMember + '/customBoardBackgrounds', method: 'post', enctype: 'multipart/form-data' }, ->
          t.input { type: 'hidden', name: 'token', value: '' }
          t.input { type: 'hidden', name: 'format', value: 'http' }
          t.span '.background-box', ->
            t.span '.icon-lg.icon-add'
          t.input '.upload-background.js-upload-image', { type: 'file', name: 'file', multiple: 'multiple', accept: 'image/*' }
